(function () {
    'use strict';

    angular.module('ib-apis-form-module')
        .controller('ApisFormController', ApisFormController);

    ApisFormController.$inject = ['$scope', 'ApisFormModel', 'ApisFormService', 'CkiDatalayerUtilsService', 'UtilsService', '$timeout', 'CkiDatalayerConstants', 'CheckinAppConstants', 'ModalService', 'ApisFormConstants', 'TravelInfoService', 'ApisFormTransformer', '$rootScope', 'MonetateUtilsService', 'MonetateConstants', 'localStorageService', 'IBCContactDataService', 'IBCContactDetailsZeroService', 'CommonsModalService', 'FlightsPassengersTransformer', 'IBCPersonalDataService', 'CommonsUserUtilsService', 'CkiDataLayerService'];
    function ApisFormController ($scope, ApisFormModel, ApisFormService, CkiDatalayerUtilsService, UtilsService, $timeout, CkiDatalayerConstants, CheckinAppConstants, ModalService, ApisFormConstants, TravelInfoService, ApisFormTransformer, $rootScope, MonetateUtilsService, MonetateConstants, localStorageService, IBCContactDataService, IBCContactDetailsZeroService, CommonsModalService, FlightsPassengersTransformer, IBCPersonalDataService, CommonsUserUtilsService, CkiDataLayerService) {


        // @ts-ignore
        const vm = this;
        vm.model = ApisFormModel;

        vm.openWhyAskForThisInfoModal = openWhyAskForThisInfoModal;
        $scope.$on('updateSecurityInfoEvent', updateApisInfo);
        $scope.$on('useDataForAll', useDataForAll);
        $scope.$on('updateUseDataForAll', updateUseDataForAll);
        $scope.$on('updateShowDataOfPassengers', updateShowDataOfPassengers);
        $scope.$on('updateShowBoardingCard', updateShowBoardingCard);
        $scope.$on('updateDestinationForAll', updateDestinationForAll);
        $scope.$on('updateOriginForAll', updateOriginForAll);
        $scope.$on('openModal', openModal);
        $scope.$on('deleteDocument', deleteDocument);


        if (!UtilsService.checkConfirmationPNR()) {
            activate();
        }

        function activate () {
            vm.model.initializeModel();
            // PUSH DATALAYER OBJECT
            $timeout(() => {
                const quadrigam = CheckinAppConstants.QUADRIGAM.APIS_PASSENGERS;

                /* INIT DELETE GA4 MIGRATION*/
                const extendedDatalayerInfo = {};
                CkiDatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, extendedDatalayerInfo, UtilsService.isUserLogged());
                CkiDatalayerUtilsService.sendDatalayerEvent(CkiDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
                /* FIN DELETE GA4 MIGRATION*/
                const extendedDigitalDataInfo = {};
                CkiDatalayerUtilsService.setProcessAndStep(CkiDatalayerConstants.DATALAYER_FLOW_CKI.PROCESS, CkiDatalayerConstants.DATALAYER_FLOW_CKI[quadrigam], quadrigam);
                CkiDatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, extendedDigitalDataInfo, UtilsService.isUserLogged());
                CkiDatalayerUtilsService.updateDatalayerViewEvent();
                CkiDataLayerService.digitalDataEcommerceEventAPIS();

                MonetateUtilsService.updateMonetateWithQuadrigam(MonetateConstants.MONETATE_INFO.SETPAGETYPE, CheckinAppConstants.QUADRIGAM.APIS_PASSENGERS);
                $rootScope.$broadcast('updateDatalayer');
                $rootScope.$broadcast('sendUpdateToMonetate');
            });
            UtilsService.setTitlePage(CheckinAppConstants.TITLE_PAGE.APIS_PASSENGERS, 1400);
            ApisFormService.searchApisInfo().then((data) => {
                vm.model.apisPassengerInfo = data.passengersInfo;
                vm.model.gdprInfo = data.gdprInfo;
                vm.model.showData = {
                    showContactData: true,
                    emergencyInfo: true,
                    additionalInfo: true,
                    useInTransitForAll: false,
                    useAdditionalForAll: !data.passengersInfo.showUseForAll.state,
                    useEmergencyForAll: !data.passengersInfo.showUseForAll.state,
                    showBoardingCard: data.passengersInfo.showBoardingCard,
                    showUseForAll: data.passengersInfo.showUseForAll
                };
            });
        }


        /**
         * Control boarding check of passenger for not disable last check.
         * @param {Object} event the angular event thrown
         * @param {String} pasID the passenger identifier who threw the event
         */
        function updateShowBoardingCard (event, pasID) {
            let i, count = 0, pasCount = 0;
            for (i = 0; i < vm.model.apisPassengerInfo.passengers.length; i++) {
                if (!vm.model.apisPassengerInfo.passengers[i].basicInfo.isInfant) {
                    //Infant must have same state as parent
                    if (vm.model.apisPassengerInfo.passengers[i].id === pasID && i + 1 < vm.model.apisPassengerInfo.passengers.length
                        && vm.model.apisPassengerInfo.passengers[i + 1].basicInfo.isInfant) {
                        vm.model.apisPassengerInfo.passengers[i + 1].boardingCard = vm.model.apisPassengerInfo.passengers[i].boardingCard;
                    }
                    if (!vm.model.apisPassengerInfo.passengers[i].boardingCard) {
                        count++;
                    }
                    pasCount++;
                }
            }
            vm.model.showData.showBoardingCard = (pasCount - count) > 1;
        }


        /**
         * Open modal window with text received
         * @param {Object} event Event received
         * @param {String} text Text to show in modal
         */
        function openModal (event, text) {
            const modalObject = {
                title: {
                    message: 'MOD_INFO_TITLE',
                    needsTranslate: true
                },
                needsTranslate: true,
                message: text,
                idModal: 'MOD_INFO_TITLE'
            };
            ModalService.showGenericModal(modalObject, false).result.then(angular.noop, angular.noop);
        }

        /**
         * Change state of passenger for show/hidden passenger in data contact form
         * @param {Object} evt Event
         * @param {String} passengerIndex ID of passenger for get values
         * @param {String} type Type of options selected in form
         */
        function useDataForAll (evt, passengerId, type) {
            ApisFormService.updatePassengersDataContact(vm.model.apisPassengerInfo.passengers, passengerId, type);
        }

        /**
         * Change/Update state of check of use for all pasenger when passengers selected for not boarding
         * @param {Object} evt
         * @param {Int} passengerId  ID of passenger selected
         */
        function updateUseDataForAll (evt, passengerId) {
            ApisFormService.updatePassengersDataContact(vm.model.apisPassengerInfo.passengers, passengerId, ApisFormConstants.TYPE_DATA_FORM.UPDATE_SHOW_FOR_ALL, false, vm.model.showData);
        }


        /**
         * Disable show data of passengers without option check for all users on true
         * @param {Object} evt
         * @param {String} passengerId Id of passenger with check for all user with state true
         */
        function updateShowDataOfPassengers (evt, passengerId) {
            ApisFormService.updatePassengersDataContact(vm.model.apisPassengerInfo.passengers, passengerId, ApisFormConstants.TYPE_DATA_FORM.UPDATE_SHOW_FOR_ALL, true, vm.model.showData);
        }

        /**
       * Copy information destination of passenger selected to all passengers
       * @param {*} index
       */
        function updateDestinationForAll (evt, index) {
            ApisFormService.updateDestinationForAll(vm.model.apisPassengerInfo.passengers, vm.model.showData.useInTransitForAll, index);
        }

        /**
       * Copy information origin of passenger selected to all passengers
       * @param {*} index
       */
        function updateOriginForAll (evt, index) {
            ApisFormService.updateOriginForAll(vm.model.apisPassengerInfo.passengers, index);
        }

        /**
         * Delete travel info document for passenger in service
         * @param {Object} evt Event recived
         * @param {Object} document Document selected for delete
         */

        function deleteDocument (evt, document) {
            TravelInfoService.deleteTravelInfo(ApisFormTransformer.getDocument(document)).then(() => {
                ApisFormService.deleteTravelInfoDocument(document, vm.model.apisPassengerInfo.passengers);
                $scope.$broadcast('changeDocument');
            }, angular.noop);
        }
        
        /**
        * Updates the passengers information to the server if every form is valid. If not change the tab to the first
        * invalid form.
        */
        function updateApisInfo () {
            const allFormValidInfo = allFormAreValid();
            let errorIndex, posErrorPassenger;
            vm.form.$submitted = true;

            if (allFormValidInfo.isValid && vm.form.$valid && vm.model.apisPassengerInfo.contactDataInfo.allTrueInfo) {

                const userLogged = localStorageService.get('userLogged');
                const isUserInBook = checkUserInBook(vm.model.apisPassengerInfo.passengers);
                const userLoggedIndex = checkUserLoggedIndex(vm.model.apisPassengerInfo.passengers);
                const usrData = localStorageService.get('customerData');

                let genderEqual;
                let contactDataEqual;
                if(userLogged && isUserInBook) {

                    let serviceToCall;
                    if (CommonsUserUtilsService.isIbPlus()) {
                        serviceToCall = IBCContactDataService.getContactData;
                    } else {
                        serviceToCall = IBCContactDetailsZeroService.getContactDetailsData;
                    }
                    serviceToCall().then((data) => {
                        localStorageService.set('contactDetails', data.data);
                    });
                    const newEmail = vm.model.apisPassengerInfo.passengers[userLoggedIndex].contactData.additionalInfo.email;
                    const newPhone = vm.model.apisPassengerInfo.passengers[userLoggedIndex].contactData.additionalInfo.phone;
                    const newPrefix = '+' + vm.model.apisPassengerInfo.passengers[userLoggedIndex].contactData.additionalInfo.prefix;
                    const newGender = vm.model.apisPassengerInfo.passengers[userLoggedIndex].basicInfo.gender;
                    const currentGender = usrData.personalInfo.gender.toUpperCase();
                    const currentEmailAddress = usrData.personalInfo.contactEmail;
                    const currentPhoneNumber = usrData.personalInfo.telecomAddresses.number;
                    const currentPrefixNumber = usrData.personalInfo.telecomAddresses.countryDiallingCode;
                    genderEqual =newGender === currentGender;
                    contactDataEqual =genderEqual && (currentEmailAddress === newEmail) && (currentPhoneNumber === newPhone) && (currentPrefixNumber === newPrefix);
                }else{
                    contactDataEqual = true;
                }

                if(haveToSaveData(!contactDataEqual, userLogged)) {
                    CommonsModalService.showGenericModal(true, 'generic-complete-modal.html', CheckinAppConstants.SAVE_MODAL_CHANGES, null).result.then(() => {
                        checkContactDetails(vm.model.apisPassengerInfo, usrData, userLoggedIndex, genderEqual);
                    }, ()=>{
                        ApisFormService.updateApisInfo(vm.model).then(angular.noop, (error) => {
                            if (error && error.errorCode === 409) {
                                $scope.$broadcast('setTabEventWithId', error.passengers);
                                ApisFormService.updateStatusPassengers(vm.model.apisPassengerInfo.passengers, vm.model.showData);
                                posErrorPassenger = ApisFormTransformer.getPositionPassenger(vm.model.apisPassengerInfo.passengers, error.passengers);
                                $timeout(() => {
                                    angular.element('html, body').animate({ scrollTop: angular.element(ApisFormConstants.TAB_SCROLL_ID + posErrorPassenger).offset().top - 70 });
                                });
                            }
                        });
                    });
                }else{
                    ApisFormService.updateApisInfo(vm.model).then(angular.noop, (error) => {
                        if (error && error.errorCode === 409) {
                            $scope.$broadcast('setTabEventWithId', error.passengers);
                            ApisFormService.updateStatusPassengers(vm.model.apisPassengerInfo.passengers, vm.model.showData);
                            posErrorPassenger = ApisFormTransformer.getPositionPassenger(vm.model.apisPassengerInfo.passengers, error.passengers);
                            $timeout(() => {
                                angular.element('html, body').animate({ scrollTop: angular.element(ApisFormConstants.TAB_SCROLL_ID + posErrorPassenger).offset().top - 70 });
                            });
                        }
                    });
                }
            } else {
                errorIndex = !allFormValidInfo.isValid ? allFormValidInfo.index : vm.model.apisPassengerInfo.passengers.length;
                $scope.$broadcast('setTabEvent', errorIndex);
                $timeout(() => {
                    angular.element('html, body').animate({ scrollTop: angular.element(ApisFormConstants.TAB_SCROLL_ID + errorIndex).offset().top - 70 });
                });
            }
        }

        function checkUserInBook (passengers) {
            const frequentFlyer = localStorageService.get('FFUser');
            let result = false;
            for (let i = 0; i < passengers.length; i++) {
                if((passengers[i].frequentFlyer && passengers[i].frequentFlyer.info && passengers[i].frequentFlyer.info.number !== undefined && passengers[i].frequentFlyer.info.number !== null)  && frequentFlyer !== null && frequentFlyer !== undefined && passengers[i].frequentFlyer.info.number.replace(/^0+/, '') === frequentFlyer.replace(/^0+/, '')) {
                    result = true;
                }
            }
            return result;
        }

        function checkUserLoggedIndex (passengers) {
            const frequentFlyer = localStorageService.get('FFUser');
            let result = null;
            for (let i = 0; i < passengers.length; i++) {
                if((passengers[i].frequentFlyer && passengers[i].frequentFlyer.info && passengers[i].frequentFlyer.info.number !== undefined && passengers[i].frequentFlyer.info.number !== null)  && frequentFlyer !== null && frequentFlyer !== undefined && passengers[i].frequentFlyer.info.number.replace(/^0+/, '') === frequentFlyer.replace(/^0+/, '')) {
                    result = i;
                }
            }
            return result;
        }

        function haveToSaveData (contactDataEqual, userLogged) {
            const isSoftUser = CommonsUserUtilsService.isSoftUser();
            return contactDataEqual && userLogged && !isSoftUser;
        }

        function checkContactDetails (model, usrData, userLoggedIndex, genderEqual) {
            const email = model.passengers[userLoggedIndex].contactData.additionalInfo.email;
            const prefix = model.passengers[userLoggedIndex].contactData.additionalInfo.prefix;
            const number = model.passengers[userLoggedIndex].contactData.additionalInfo.phone;
            const gender = model.passengers[userLoggedIndex].basicInfo.gender;
            const contactDetails = localStorageService.get('contactDetails');

            IBCPersonalDataService.getPersonalData().then((data) => {
                const newPersonalData = data.data;
                if(!genderEqual) {
                    newPersonalData.gender = gender;
                    usrData.personalInfo.gender = gender;
                    IBCPersonalDataService.updatePersonalData(newPersonalData).then();
                    localStorageService.set('customerData', usrData);
                }
            });
            const newContactData = {
                email: email,
                phone: {
                    prefix: prefix,
                    number: number
                }
            };

            if (CommonsUserUtilsService.isIbPlus()) {
                IBCContactDataService.updateContactData(FlightsPassengersTransformer.generateUpdataContactDetails(newContactData, contactDetails)).then(() => {
                    CommonsModalService.showGenericModal(true, 'generic-info-modal.html', CheckinAppConstants.SAVE_CORRECT_LITERALS, null).result.then(() => {
                        const newUserData = {
                            ...usrData
                        };
                        newUserData.personalInfo.contactEmail = email;
                        newUserData.personalInfo.telecomAddresses.number = number;
                        localStorageService.set('customerData', newUserData);
                        ApisFormService.updateApisInfo(vm.model).then(angular.noop, (error) => {
                            if (error && error.errorCode === 409) {
                                $scope.$broadcast('setTabEventWithId', error.passengers);
                                ApisFormService.updateStatusPassengers(vm.model.apisPassengerInfo.passengers, vm.model.showData);
                                const posErrorPassenger = ApisFormTransformer.getPositionPassenger(vm.model.apisPassengerInfo.passengers, error.passengers);
                                $timeout(() => {
                                    angular.element('html, body').animate({ scrollTop: angular.element(ApisFormConstants.TAB_SCROLL_ID + posErrorPassenger).offset().top - 70 });
                                });
                            }
                        });
                    });
                }, () => {
                    CommonsModalService.showGenericModal(true, 'generic-info-modal.html', CheckinAppConstants.SAVE_ERROR_LITERALS, null).result.then(() => { }, () => { });
                });
            } else {
                IBCContactDetailsZeroService.updateContactDetailsData(FlightsPassengersTransformer.generateUpdataContactDetails(newContactData, contactDetails)).then(() => {
                    CommonsModalService.showGenericModal(true, 'generic-info-modal.html', CheckinAppConstants.SAVE_CORRECT_LITERALS, null).result.then(() => {
                        const newUserData = {
                            ...usrData
                        };
                        newUserData.personalInfo.contactEmail = email;
                        newUserData.personalInfo.telecomAddresses.number = number;
                        localStorageService.set('customerData', newUserData);
                        ApisFormService.updateApisInfo(vm.model).then(angular.noop, (error) => {
                            if (error && error.errorCode === 409) {
                                $scope.$broadcast('setTabEventWithId', error.passengers);
                                ApisFormService.updateStatusPassengers(vm.model.apisPassengerInfo.passengers, vm.model.showData);
                                const posErrorPassenger = ApisFormTransformer.getPositionPassenger(vm.model.apisPassengerInfo.passengers, error.passengers);
                                $timeout(() => {
                                    angular.element('html, body').animate({ scrollTop: angular.element(ApisFormConstants.TAB_SCROLL_ID + posErrorPassenger).offset().top - 70 });
                                });
                            }
                        });
                    });
                }, () => {
                    CommonsModalService.showGenericModal(true, 'generic-info-modal.html', CheckinAppConstants.SAVE_ERROR_LITERALS, null).result.then(() => { }, () => { });
                });
            }

        }

        /**
         * Checks if all passenger forms are valid and return the first index which is not
         */
        function allFormAreValid () {
            let i = 0, found = false;
            const info = { isValid: true, index: 0 };
            while (!found && i < vm.model.apisPassengerInfo.passengers.length) {
                found = !vm.model.apisPassengerInfo.passengers[i].formStatus ||
                    (vm.model.apisPassengerInfo.passengers[i].formStatus === ApisFormConstants.TAB_STATES.NOT_TOUCHED ||
                        vm.model.apisPassengerInfo.passengers[i].formStatus === ApisFormConstants.TAB_STATES.WARNING);
                i++;
            }
            info.isValid = !found;
            info.index = i - 1;
            return info;
        }

        /**
         * Opens the generic modal with the information about why we ask for APIS information
         */
        function openWhyAskForThisInfoModal () {
            const modalObject = {
                title: {
                    message: 'APIS_WHY_ASK_FOR_INFO_MODAL_TITLE',
                    needsTranslate: true
                },
                needsTranslate: true,
                message: 'APIS_WHY_ASK_FOR_INFO_MODAL_MESSAGE',
                idModal: 'APIS_WHY_ASK_FOR_INFO_MODAL'
            };
            ModalService.showGenericModal(modalObject, false).result.then(angular.noop, angular.noop);
        }
    }
})();
